/** @format */
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'homefield-product-badge',
  templateUrl: './product-badge.component.html',
  styleUrl: './product-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldProductBadgeComponent implements OnInit, OnChanges {
  @Input() imageBadgeName = '';
  @Input() chainIdentifierAbbr = 'dsg';
  @Input() pageType = 'pdp';
  @Input() hasMobileAndDesktopImage = true;

  imgBadge = '';
  mobileImgBadge = '';

  setImageRoute(isMobile = false): string {
    const imageBadge = encodeURIComponent(this.imageBadgeName);
    return `https://images.dickssportinggoods.com/assets/badges/${
      this.chainIdentifierAbbr
    }/${this.pageType.toLowerCase()}/${this.pageType.toUpperCase()}-${
      this.hasMobileAndDesktopImage ? (isMobile ? 'M-' : 'D-') : ''
    }${imageBadge}.svg`;
  }

  ngOnInit() {
    if (!this.imageBadgeName) {
      return;
    }
    this.imgBadge = this.setImageRoute();
    this.mobileImgBadge = this.setImageRoute(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageBadgeName']) {
      this.imageBadgeName = changes['imageBadgeName'].currentValue;
      this.imgBadge = this.setImageRoute();
      this.mobileImgBadge = this.setImageRoute(true);
    }
  }
}
